export enum UserStatus {
  SUSPENDED = "inactive",
  USING = "active",
}
